// extracted by mini-css-extract-plugin
export default {"companyNameParagraph":"CompanyNameInfoContent_companyNameParagraph__D5oMA","vector":"CompanyNameInfoContent_vector__xY-wr","greenBall":"CompanyNameInfoContent_greenBall__drdLx"};